import React from 'react';
import { CalendarClock } from 'lucide-react';
import { api } from '@/lib/api';
import ScheduleManagerView from '@/components/schedules/ScheduleManagerView';

export default function TenantSchedulesPage() {
  return (
    <ScheduleManagerView
      title="Tenant Schedules"
      description="Every recurring automation configured by anyone in your tenant — report bursts, dashboard exports, alerts, anomaly scans and executive briefings. Pause, edit or delete any of them."
      Icon={CalendarClock}
      testidPrefix="tenant-schedules"
      loadFn={api.listTenantSchedules}
      toggleFn={api.tenantToggleSchedule}
      deleteFn={api.tenantDeleteSchedule}
      editFn={api.tenantEditSchedule}
    />
  );
}
